import { render, staticRenderFns } from "./UjianEvent.vue?vue&type=template&id=7f6e2857&scoped=true"
import script from "./UjianEvent.vue?vue&type=script&lang=js"
export * from "./UjianEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6e2857",
  null
  
)

export default component.exports